<div class="card">
    <div class="card-header bg-info text-white">
        <h5><i class="fas fa-percent"></i> Gestión de Porcentajes</h5>
    </div>
    <div class="card-body">

        <!-- Formulario -->
        <div class="row mb-4">
            <div class="col-12">
                <h6 class="border-bottom pb-2">
                    {{ editMode ? 'Editar' : 'Nuevo' }} Porcentaje
                </h6>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <div class="form-group">
                    <label for="tipo">Tipo *</label>
                    <select class="form-control"
                            id="tipo"
                            [(ngModel)]="porcentajeForm.tipo">
                        <option value="aporte">Aporte</option>
                        <option value="contribucion">Contribución</option>
                    </select>
                </div>
            </div>

            <div class="col-md-2">
                <div class="form-group">
                    <label for="porcentaje">Porcentaje *</label>
                    <input type="number"
                           class="form-control"
                           id="porcentaje"
                           [(ngModel)]="porcentajeForm.porcentaje"
                           step="0.0001"
                           min="0"
                           max="9.9999"
                           placeholder="Ej: 0.0255">
                    <small class="form-text text-muted">
                        {{ porcentajeForm.porcentaje ? formatearPorcentaje(porcentajeForm.porcentaje) : '2.55%' }}
                    </small>
                </div>
            </div>

            <div class="col-md-2">
                <div class="form-group">
                    <label for="anio">Año *</label>
                    <input type="number"
                           class="form-control"
                           id="anio"
                           [(ngModel)]="porcentajeForm.anio"
                           min="2000"
                           max="2100"
                           placeholder="2024">
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group">
                    <label for="titulo">Título *</label>
                    <input type="text"
                           class="form-control"
                           id="titulo"
                           [(ngModel)]="porcentajeForm.titulo"
                           maxlength="255"
                           placeholder="Ej: Standard 2024 - Aporte">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="descripcion">Descripción</label>
                    <textarea class="form-control"
                              id="descripcion"
                              [(ngModel)]="porcentajeForm.descripcion"
                              rows="2"
                              placeholder="Descripción detallada del porcentaje"></textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <button class="btn btn-primary"
                        (click)="guardarPorcentaje()"
                        [disabled]="loading">
                    <i class="fas" [class.fa-save]="!loading" [class.fa-spinner]="loading" [class.fa-spin]="loading"></i>
                    {{ editMode ? 'Actualizar' : 'Guardar' }}
                </button>
                <button class="btn btn-secondary ml-2"
                        (click)="limpiarFormulario()"
                        *ngIf="editMode">
                    <i class="fas fa-times"></i> Cancelar
                </button>
            </div>
        </div>

        <hr class="my-4">

        <!-- Tabla de porcentajes -->
        <div class="row">
            <div class="col-12">
                <h6 class="border-bottom pb-2">Lista de Porcentajes</h6>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div *ngIf="loading && porcentajes.length === 0" class="text-center py-4">
                    <i class="fas fa-spinner fa-spin fa-2x"></i>
                    <p class="mt-2">Cargando...</p>
                </div>

                <div *ngIf="!loading && porcentajes.length === 0" class="alert alert-info">
                    <i class="fas fa-info-circle"></i> No hay porcentajes registrados.
                </div>

                <div class="table-responsive" *ngIf="porcentajes.length > 0">
                    <table class="table table-striped table-hover">
                        <thead class="thead-dark">
                            <tr>
                                <th>ID</th>
                                <th>Tipo</th>
                                <th>Porcentaje</th>
                                <th>Año</th>
                                <th>Título</th>
                                <th>Descripción</th>
                                <th class="text-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let porcentaje of porcentajes">
                                <td>{{ porcentaje.id }}</td>
                                <td>
                                    <span class="badge" [ngClass]="getTipoBadgeClass(porcentaje.tipo)">
                                        {{ getTipoLabel(porcentaje.tipo) }}
                                    </span>
                                </td>
                                <td>
                                    <span class="badge badge-info">
                                        {{ formatearPorcentaje(porcentaje.porcentaje) }}
                                    </span>
                                </td>
                                <td>{{ porcentaje.anio }}</td>
                                <td>{{ porcentaje.titulo }}</td>
                                <td>{{ porcentaje.descripcion || '-' }}</td>
                                <td class="text-center">
                                    <button class="btn btn-sm btn-warning mr-1"
                                            (click)="editarPorcentaje(porcentaje)"
                                            title="Editar">
                                        <i class="fas fa-edit"></i>
                                    </button>
                                    <button class="btn btn-sm btn-danger"
                                            (click)="eliminarPorcentaje(porcentaje.id)"
                                            title="Eliminar">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</div>
